import type {
  MapLayerGeographyType,
} from './schema'

import { mapLayerGeographyTypes } from './schema'

export function isMapLayerGeographyType(
  type: string
): type is MapLayerGeographyType {
  return mapLayerGeographyTypes.includes(type as MapLayerGeographyType)
}

export function isSubmarketGeography<T extends { type: string }>(
  geography: T
): geography is T & { type: 'submarket' } {
  return geography.type === 'submarket'
}
